import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa'; // For the delete icon
import './oderCartItem.css'; // Ensure you have the CSS for styling
import QRImage from "../images/paymentQrCode.webp";
const OrderCartItem = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const cartItems = location.state.cartItems || ""; // Receive cartItems and totalPrice from the state
    const totalPrice = location.state.totalPrice || "";
    const [priceMSG, setPriceMSG] = useState({
        price: "",
        MSG: ""
    });
    const [address, setAddress] = useState({
        userName: "",
        phone: "",
        landmark: '',
        city: '',
        pinCode: '',
        state: ''
    });
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationData, setConfirmationData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('success');

    const handleChange = (e) => {
        setAddress({ ...address, [e.target.name]: e.target.value });
    };



    const handleConfirmOrder = () => {
        var iName = "";
        var totalQ = 0;
        cartItems.forEach((curr, index) => {
            iName += `${index + 1}:${curr.name}(${curr.quantity}), `
            totalQ += curr.quantity;
        })
        var currPrice = totalPrice;
        if (totalPrice < 500) {
            currPrice += 40;
        }
        const orderDetails = {
            userName: address.userName,
            phone: address.phone,
            itemName: iName,
            price: currPrice,
            quantity: totalQ,
            landmark: address.landmark,
            city: address.city,
            state: address.state,
            pinCode: address.pinCode
        };

        setConfirmationData(orderDetails);
        setShowConfirmation(true);
    };

    const handleSubmit = async () => {
        const currOrder = {
            ...confirmationData,
            paymentStatus: "Pending"
        };

        try {
            const response = await fetch("https://swarna-herbal-backend.onrender.com/api/orders/add-order", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(currOrder),
            });

            if (response.ok) {
                setAddress({
                    userName: "",
                    phone: "",
                    landmark: '',
                    city: '',
                    pinCode: '',
                    state: ''
                });
                setShowConfirmation(false);
                setPopupType('success');
                setPopupMessage('Your order is pending. Please complete the payment to confirm your order.');
                setShowPopup(true);
            } else {
                const error = await response.json();
                setPopupType('error');
                setPopupMessage(`Error placing order: ${error.message}`);
                setShowPopup(true);
            }
        } catch (error) {
            setPopupType('error');
            setPopupMessage(`Request failed: ${error.message}`);
            setShowPopup(true);
        }
    };

    const validateForm = () => {
        const phoneRegex = /^[6-9]\d{9}$/;
        const pinCodeRegex = /^\d{6}$/;
        const nameRegex = /^[A-Za-z ]{1,25}$/;

        if (!nameRegex.test(address.userName)) {
            alert("Name should be up to 25 characters long.");
            return false;
        }

        if (!phoneRegex.test(address.phone)) {
            alert("Phone number should be 10 digits long and start with 6, 7, 8, or 9.");
            return false;
        }

        if (!pinCodeRegex.test(address.pinCode)) {
            alert("Pincode should be exactly 6 digits.");
            return false;
        }

        return true;
    };
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userDetails"));
        setAddress({ ...address, userName: user.name, phone: user.phone });
    }, []);
    useEffect(() => {
        if (totalPrice < 500) {
            setPriceMSG({ ...priceMSG, price: totalPrice + 40, MSG: `(item price - ₹${totalPrice} + ₹40 delivery charge (to get free delivery order minimum ₹500))` })
        } else {
            setPriceMSG({ ...priceMSG, price: totalPrice, MSG: "" })
        }
    }, [totalPrice]);
    return (
        <div className="order-page">
            <h1>Confirm Order</h1>
            <div className="order-items">
                {cartItems && cartItems.length > 0 ? (
                    cartItems.map((item) => (
                        <div key={item.itemId} className="order-item">
                             <img
                    src={`https://swarna-herbal-backend.onrender.com/uploads/${item.image}`}
                    alt={item.name}
                    className="order-item-image"
                  />
                            {/* <img src={item.image} alt={item.name} className="order-item-image" /> */}
                            <div className="order-item-info">
                                <h3>{item.name}</h3>
                                <p>Price: ₹{item.offerPrice}</p>
                                <p>Quantity: {item.quantity}</p>
                                <p>Total: ₹{item.offerPrice * item.quantity}</p>
                            </div>

                        </div>

                    ))
                ) : (
                    <p>Your cart is empty.</p>
                )}
                <h2>Total Amount - &#8377;{totalPrice} </h2>
            </div>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    if (validateForm()) handleConfirmOrder();
                }}
                className="order-form"
            >
                <div>
                    <label>Your Name:</label>
                    <input
                        type="text"
                        name="userName"
                        value={address.userName}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>Phone Number:</label>
                    <input
                        type="tel"
                        name="phone"
                        value={address.phone}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>Landmark:</label>
                    <input
                        type="text"
                        name="landmark"
                        value={address.landmark}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>City:</label>
                    <input
                        type="text"
                        name="city"
                        value={address.city}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>State:</label>
                    <input
                        type="text"
                        name="state"
                        value={address.state}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div>
                    <label>Pincode:</label>
                    <input
                        type="text"
                        name="pinCode"
                        value={address.pinCode}
                        onChange={handleChange}
                        required
                    />
                </div>

                <button type="submit">Confirm Order</button>
            </form>


          {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="confirmation-modal">
          <div className="confirmation-modal-content">
            <h3>Please confirm your details</h3>
            <p><strong>Name:</strong> {confirmationData.userName}</p>
            <p><strong>Phone:</strong> {confirmationData.phone}</p>
            <p><strong>Address:</strong> {confirmationData.landmark}, {confirmationData.city}, {confirmationData.state} - {confirmationData.pinCode}</p>
            <p><strong>Product:</strong> {confirmationData.itemName}</p>
            <p><strong>Total Price:</strong> &#8377;{priceMSG.price} {priceMSG.MSG}</p>
            <div className='confirm-btn-container'>
              <button  onClick={handleSubmit}>Confirm Order</button>
              <button className="cancel-btn" onClick={() => setShowConfirmation(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="confirmation-modal">
          <div className="popup">
            <div className="popup-content">
              <h3>Your Order is Pending</h3>
              <h4>Make Payment To Confirm Your Order</h4>
              <p><strong>Total Amount:</strong> &#8377;{priceMSG.price} {priceMSG.MSG}</p>

              {/* Centered QR Code */}
              <h3><strong>Name:</strong> Sona Bhadoriya</h3>
              <div className="qr-code-container">
                <img src={QRImage} alt="QR Code" className="qr-code" />
              </div>
              <p style={{ width: "100%", textAlign: "center" }}>Or</p>

              {/* UPI ID with owner name */}
              <p><strong>UPI PhonePay/GooglePay:</strong> 7828215766</p>
              

              {/* Payment Instructions */}
              <p><strong>Important:</strong> After completing the payment, please send the payment receipt to the same number with which your order was placed WhatsApp on this number: 7828215766.</p>

              <button className="close-btn" onClick={() => setShowPopup(false)}>Close</button>
            </div>
          </div>
        </div>

      )}
        </div>
    );
};

export default OrderCartItem;
